import auth from './auth';

export default () =>
  new Headers({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Authorization: `Bearer ${auth.getParsedAuthCookie()?.accessToken}`,
  });
